module.exports = __webpack_public_path__ + "static/img/banner-1.d404d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-1.png
// module id = kv6o
// module chunks = 1